// extracted by mini-css-extract-plugin
module.exports = {"container":"footer-utility-row_container__AiuM9","list":"footer-utility-row_list__Jux7d","item":"footer-utility-row_item__WPiQF","link":"footer-utility-row_link__lVzyj"};